// extracted by mini-css-extract-plugin
module.exports = {"Error":"Error-3uemG","ErrorTitle":"ErrorTitle-1qVw8","BackLink":"BackLink-e9eYR"};